import transformStore from './transform'
import settings from '../../../components/settings'
import { appBasePath } from '../../../../utils/appBasePath'
import { clearState } from '../../../../utils/state'

const hasExplicitStoreId = (storeId) =>
  storeId !== undefined && storeId !== null && storeId !== ''

const reloadOnError = (storeData, stores = []) => {
  if (!storeData) {
    return undefined
  }

  const storeId = storeData?.variables?.storeId
  const hasStoreId = hasExplicitStoreId(storeId)

  if (storeData.error && hasStoreId) {
    /* eslint-disable no-console */
    console.warn(`Failed to fetch store. Clearing state.`)
    clearState(settings.brand)
    window.location = appBasePath
    return undefined
  }

  // Missing storeId must not fall back to 0 (would auto-select StoreId=0).
  if (storeData.store && hasStoreId) {
    const selectedStore = stores
      .filter(
        (item) =>
          +item.store.id === +storeId &&
          !settings.excludedStudioTypes.includes(item.store.storeType)
      )
      .at(0)

    return selectedStore && transformStore(selectedStore)
  }

  return undefined
}

const badaPropsChange = ({
  stores,
  StoreWithDistance,
  overrideMeetingType,
}) => ({
  store: reloadOnError(StoreWithDistance, stores),
  stores: stores
    ?.filter((storeItem) => storeItem.store.externalMeetingData.acceptMeetings)
    ?.filter(
      (storeItem) =>
        !settings.excludedStudioTypes.includes(storeItem.store.storeType)
    )
    ?.map(transformStore),
  overrideMeetingType,
})

export default badaPropsChange
